import React from 'react';

const Page404: React.FC = () => {

   return (
      <div className="page__404">
         <h2 className="page__404-title">404</h2>
      </div>
   );
};

export default Page404;
